/* RC lazy video: below-fold videos do not download until they are near the viewport.

   IntersectionObserver only. No getBoundingClientRect, no MutationObserver, no
   timers: the observer's first callback for each video says where it is
   (entry.isIntersecting, entry.boundingClientRect) without forcing a layout.

   Handles three kinds of <video>:
   1. <video src> / <video><source src>: if it is not on the first screen when the
      page loads, its src is parked in data-rc-src and restored when it gets near.
   2. <video data-src data-rc-defer>: markup that never had a src (for example the
      home "steps" videos). src is set from data-src when it gets near.
   3. Anything with data-rc-nolazy, or data-src without data-rc-defer, is left alone
      (those sections run their own loaders, e.g. the hero, reels and PDP gallery).
   Autoplay intent (the autoplay attribute, or data-rc-auto) is kept: the video is
   played, muted, once its src is set. */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var io;
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;

  function park(v) {
    var src = v.getAttribute('src');
    var sourceEl = null;
    if (!src) {
      sourceEl = v.querySelector('source[src]');
      if (sourceEl) src = sourceEl.getAttribute('src');
    }
    if (!src) return false;
    v.setAttribute('data-rc-lazy', '1');
    v.setAttribute('data-rc-src', src);
    if (sourceEl) { sourceEl.removeAttribute('src'); v.setAttribute('data-rc-srcel', '1'); }
    v.removeAttribute('src');
    v.setAttribute('preload', 'none');
    if (v.hasAttribute('autoplay')) { v.setAttribute('data-rc-auto', '1'); v.removeAttribute('autoplay'); }
    try { v.load(); } catch (e) {}
    return true;
  }

  function restore(v) {
    var src = v.getAttribute('data-rc-src') || v.getAttribute('data-src');
    if (!src) return;
    if (v.getAttribute('data-rc-srcel')) {
      var se = v.querySelector('source');
      if (se) se.setAttribute('src', src);
    } else {
      v.setAttribute('src', src);
    }
    v.removeAttribute('data-rc-src');
    v.setAttribute('data-rc-lazy', 'done');
    try { v.load(); } catch (e) {}
    v.setAttribute('preload', 'metadata');
    if (v.hasAttribute('data-rc-auto') || v.hasAttribute('autoplay')) {
      v.muted = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    }
  }

  function onEntries(entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      var v = e.target;
      var state = v.getAttribute('data-rc-lazy');

      if (!state) {
        /* First report for this video: classify it. */
        if (v.hasAttribute('data-rc-defer')) {
          v.setAttribute('data-rc-lazy', '1');
          if (e.isIntersecting) { io.unobserve(v); restore(v); }
          continue;
        }
        var r = e.boundingClientRect;
        var hidden = r.width === 0 && r.height === 0;
        var vh = window.innerHeight || 800; /* rootBounds includes the 400px margin */
        if (!hidden && r.top < vh * 1.15) { io.unobserve(v); continue; } /* first screen stays eager */
        if (!park(v)) io.unobserve(v);
        continue;
      }

      if (state === '1' && e.isIntersecting) {
        io.unobserve(v);
        restore(v);
      }
    }
  }

  function scan(root) {
    var vids = (root || document).querySelectorAll('video:not([data-rc-lazy]):not([data-rc-nolazy])');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (seen) { if (seen.has(v)) continue; seen.add(v); }
      if (v.hasAttribute('data-src') && !v.hasAttribute('data-rc-defer')) continue; /* owned by a section loader */
      io.observe(v);
    }
  }

  /* rootMargin extends the viewport by 400px, so "intersecting" means "near". The
     first-screen test above uses the real rect, so only the viewport itself (plus
     15%) stays eager, as before. */
  io = new IntersectionObserver(onEntries, { rootMargin: '400px 0px' });

  scan();
  /* Theme editor: sections are re-rendered in place. */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
